import React from 'react';
import NvIcon from 'shared/components/nv-icon';
import { config } from '@config/pendo.config.json';
import { askNovoAIBtnComponent } from '../styles';

interface AskNovoAiButtonProps {
  disabled?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
  isSmall?: boolean;
  dataQa?: string;
}

const AskNovoAIButton = ({
  onClick = () => {},
  children,
  disabled,
  isSmall,
  dataQa,
}: AskNovoAiButtonProps) => (
  <div css={askNovoAIBtnComponent(disabled, isSmall)} className='button-wrapper'>
    <div className='gradient-border'>
      <button disabled={disabled} type='button' className='novoai-button' onClick={onClick} data-qa={dataQa || config.pendo.aiLearning.askNovoAiButton}>
        <NvIcon icon='gen-ai' size={isSmall ? 'xss-smallest' : 'small'} className='novoai-icon' />
        {children}
      </button>
    </div>
  </div>
);

export default AskNovoAIButton;
